/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import { classSet } from '@umu/umu-dom';
import React, { Component } from 'react';
import './button.scss';

// 类别，控制布局。除了颜色不同外，其它都相同的属于同一类。是否有边框、是否有背景图案等都属于不同类别。
export type ButtonAlias = 'plain' | 'striking' | 'text';

// 类型，控制颜色。色系需要符合产品规范的定义。
export type ButtonType = 'primary' | 'optional' | 'white' | 'grey' | 'blue-border' | 'grey-border';

// 尺寸，控制边距、字号等大小。
export type ButtonSize = 'medium' | 'small' | 'big';

export interface IButtonProps {
    children: React.ReactNode | string;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    href?: string;
    target?: string;
    alias?: ButtonAlias; // 分类
    type?: ButtonType; // 按钮类型
    size?: ButtonSize; // 尺寸
    disabled?: boolean;
    iconBefore?: JSX.Element;
    iconAfter?: JSX.Element;
}

export default class Button extends Component<IButtonProps> {
    public static defaultProps: Partial<IButtonProps> = {
        alias: 'plain',
        type: 'primary',
        size: 'medium',
    };

    public onClick = (e: React.MouseEvent) => {
        const { onClick, disabled } = this.props;
        if (onClick && !disabled) {
            if (typeof e.persist === 'function') {
                e.persist();
            }
            onClick(e);
        }
    };

    public render() {
        const {
            className,
            alias,
            type,
            size,
            children,
            href,
            target = '',
            disabled,
            iconBefore,
            iconAfter,
        } = this.props;

        let element = 'a';
        if (!href) {
            element = 'span';
        }

        const clsName = (className && `${className}`) || '';
        const disabledCls = (disabled && `btn-disabled`) || '';

        const btnCls = classSet(clsName, 'btn', `alias-${alias!}`, `type-${type!}`, `size-${size}`, disabledCls);

        const elementProps = {
            className: btnCls,
            onClick: this.onClick,
            href,
            target,
        };

        return React.createElement(
            element,
            elementProps,
            iconBefore && React.createElement('span', { className: 'btn-icon' }, iconBefore),
            React.createElement('span', { className: 'btn-inner' }, children),
            iconAfter && React.createElement('span', { className: 'btn-icon' }, iconAfter),
        );
    }
}
